var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar-item",on:{"click":_vm.itemClick}},[(!_vm.isActive)?_c('div',[_vm._t("item-icon")],2):_c('div',[_vm._t("item-icon-active")],2),_c('div',{style:(_vm.activeStyle)},[_vm._t("item-text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }